export default "__VITE_ASSET__DaHMX8t5__"